/**
 * Codmonボタンディレクティブ
 *
 * @description
 * このディレクティブは、カスタマイズ可能なボタンを提供します。バリアント、サイズ、アイコン、クリックイベントなどを設定可能です。
 *
 * @example
 * // カスタムバリアントやサイズ、アイコン付きボタン
 * <codmon-button
 *   variant="primary"
 *   size="large"
 *   on-click="addFunction()"
 *   leadingIconName="checkmark-outline">
 *   カスタム内容
 * </codmon-button>
 *
 * @example
 * // 任意の内容を含むボタン
 * <codmon-button>任意の内容</codmon-button>
 *
 * @property {string} variant - ボタンの種類を指定 (例: primary, secondary, neutral, caution, danger)
 * @property {string} size - ボタンのサイズを指定 (例: small, medium, large)
 * @property {boolean} [ngDisabled=false] - ボタンの無効化状態を指定
 * @property {Function} onClick - ボタンのクリックイベントを指定
 * @property {string} [leadingIconName] - ボタン内の先頭アイコンを指定
 */
angular.module('inspinia').directive('codmonButton', () => {
  return {
    restrict: 'E',
    scope: {
      variant: '@',
      ngDisabled: '=?',
      size: '@',
      onClick: '&',
      leadingIconName: '@',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_button.html?${new Date().getTime()}`,
    link($scope) {
      // デフォルト値の設定
      $scope.ngDisabled = !!$scope.ngDisabled;

      const buttonSizes = ['small', 'medium', 'large'];
      $scope.size = buttonSizes.includes($scope.size) ? $scope.size : 'medium';

      const buttonVariants = ['primary', 'secondary', 'neutral', 'caution', 'danger'];
      $scope.type = buttonVariants.includes($scope.type) ? $scope.type : 'primary';

      // クリックイベント
      $scope.onClickCodmonButton = () => {
        if (!$scope.ngDisabled && $scope.onClick) $scope.onClick();
      };

      // CSSクラス名を返す
      $scope.codmonButtonClasses = () => {
        const buttonClasses = {
          'codmon-button': true,
        };
        if ($scope.variant) {
          buttonClasses[`codmon-button--${$scope.variant}`] = true;
        }
        if ($scope.leadingIconName) {
          buttonClasses['codmon-button--leadingIcon'] = true;
        }
        if ($scope.size) {
          buttonClasses[`codmon-button--${$scope.size}`] = true;
        }
        if ($scope.ngDisabled) {
          buttonClasses['codmon-button--disabled'] = true;
        }
        return buttonClasses;
      };

      // アイコンクラス
      $scope.codmonIconClasses = () => {
        const iconClasses = ['codmon-icon'];
        if ($scope.size) {
          iconClasses.push(`codmon-icon--${$scope.size}`);
        }
        return iconClasses;
      };

      // アイコンサイズを返す
      $scope.codmonIconSize = () => {
        switch ($scope.size) {
          case 'small':
            return { width: '16', height: '16' };
          case 'large':
            return { width: '20', height: '20' };
          case 'medium':
          default:
            return { width: '20', height: '20' };
        }
      };
    },
  };
});
